import { render, staticRenderFns } from "./DetailUpdateModal.vue?vue&type=template&id=ef07f2ca&scoped=true"
import script from "./DetailUpdateModal.vue?vue&type=script&lang=js"
export * from "./DetailUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./DetailUpdateModal.vue?vue&type=style&index=0&id=ef07f2ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef07f2ca",
  null
  
)

export default component.exports